import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import ModalFile from '../../Partials/ModalFile';
import {showModalPageClass, hideModalPageClass, setTextInputLongitud, generateSlugAutomatico, setTestData, setDataForm} from '../../../functions';
import axios from 'axios';
import {BASE_URL_PAIS} from '../../../constants';
import {DropDownList} from '../../Elements/Select/dropdown';

export default class FichaPaisNuevo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            etiquetaSeleccionada: "",
            contenidoSeleccionado: "",
            fichaPais: {
                estado:             false,
                fpai_Slug:          '',
                CeldaValor1:          '',
                bandera: '',
                banderaData: '',
                imagenSEO: '',
                imagenSEOData: '',
                seguirBuscadoresSEO: false,
                mostrarBuscadoresSEO: false,
                mercadoCodigo: -1,
            },
            Validacion: {
                CeldaValor1: {
                    Error: false,
                    RequeridoError: "Se requiere el código de país."
                },
                nombrePais: {
                    Error: false,
                    RequeridoError: "El campo nombre es requerido."
                },
                fpai_Slug: {
                    Error: false,
                    RequeridoError: "El campo Slug es requerido."
                },
                // bandera: {
                //     Error: false,
                //     RequeridoError: "Subir una imagen para el campo bandera requerido."
                // },
            },
           
            guardando: false,
            miniaturaBandera: '',
            miniaturaImagenSEO: ''
        }

        this.handleInputChange  = this.handleInputChange.bind(this);
    }

    handleClickGuardar(e) {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
            const url = `${API_URL}FichaPaisUX/Insertar`;
            let fichaPais = {...this.state.fichaPais};
            
            setDataForm(fichaPais);
            fichaPais["UsuarioCreacion"] = cookie.load('user').nUsuCodigo;
            fichaPais["EnlaceVerMas"] = "";
            fichaPais["estado"] = Number(fichaPais["estado"]);

            let newState = this.state;
            let hasError = false;

            if (fichaPais.CeldaValor1 =='' || fichaPais.CeldaValor1 == null) {
                newState.Validacion.CeldaValor1.Error = true;
                toast.error(newState.Validacion.CeldaValor1.RequeridoError);
                hasError = true;
            }
            
            if (fichaPais.nombrePais == '' || fichaPais.nombrePais == null) {
                newState.Validacion.nombrePais.Error = true;
                toast.error(newState.Validacion.nombrePais.RequeridoError);
                hasError = true;
            }
            
            if (fichaPais.fpai_Slug == '' || fichaPais.fpai_Slug == null) {
                newState.Validacion.fpai_Slug.Error = true;
                toast.error(newState.Validacion.fpai_Slug.RequeridoError);
                hasError = true;
            }
            
            // if (fichaPais.bandera == '' || fichaPais.bandera == null) {
            //     newState.Validacion.bandera.Error = true;
            //     toast.error(newState.Validacion.bandera.RequeridoError);
            //     hasError = true;
            // }
            
            if(hasError){
                this.setState(newState);
                return;
            }
            axios.post(url, JSON.stringify(JSON.stringify(fichaPais)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                me.setState({ guardando:false });
                if(data.data.result.status){
                    this.props.history.push({
                        pathname: '/ficha-pais'
                    });
                }
            }).catch((error)=> {
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    handleClickCancel(e) {
        this.props.history.push({
            pathname: '/ficha-pais'
        });
    }

    handleInputChange(event){
        const target = event.target;
        if(target.id == 'fpai_Slug'){
            let validaciones = this.state.Validacion;
            validaciones[target.id].Error = false;
            this.setState({
                Validacion: validaciones
            });
        }
    }

    showModalFile = (clase = "") => {
        showModalPageClass(clase);
    }

    onSelectArchivo(fileName, fileData, fieldName, fieldNameData){
        let fichaPais = {... this.state.fichaPais};
        
        fichaPais[fieldName] = fileName;
        fichaPais[fieldNameData] = fileData;

        document.getElementById(fieldName).value = fileName;

        this.setState({
            fichaPais
        });

        if(fieldName == "bandera"){
            let validaciones = this.state.Validacion;
            validaciones[fieldName].Error = false;
            this.setState({
                Validacion: validaciones,
                miniaturaBandera: fileData
            }); 
        }

        if(fieldName == "mapa"){
            let validaciones = this.state.Validacion;
            validaciones[fieldName].Error = false;
            this.setState({
                Validacion: validaciones,
                miniaturaMapa: fileData
            }); 
        }

        if(fieldName == "imagenSEO"){
            this.setState({
                miniaturaImagenSEO: fileData
            }); 
        }

        hideModalPageClass(`div${fieldName}Upload`);
    }

    checkedValidate = (item) => {
        let fichaPais = this.state.fichaPais;
        fichaPais[item] = !fichaPais[item];

        this.setState({
            fichaPais
        });
    }

    onTituloChange(){
        let CeldaValor1 = document.getElementById('CeldaValor1').value;
        let nombrePaisVal = document.getElementById('nombrePais').value;
       
        let validaciones = this.state.Validacion;
        validaciones['CeldaValor1'].Error = false;
        validaciones['nombrePais'].Error = false;
        validaciones['fpai_Slug'].Error = false;

        this.setState({
            Validacion: validaciones
        });

        document.getElementById('tituloSEO').value = nombrePaisVal;
        document.getElementById('enlaceSEO').value = generateSlugAutomatico(nombrePaisVal);
        document.getElementById('fpai_Slug').value = generateSlugAutomatico(nombrePaisVal);
        setTextInputLongitud(['fpai_Slug', 'enlaceSEO', 'tituloSEO', 'CeldaValor1']);
    }

    handleInputChange(event){
        console.log("handleInputChange")

        let objetoSeleccionado = event.target.value
        if(typeof objetoSeleccionado != 'undefined'){
            if(objetoSeleccionado.value != 0){
                console.log(objetoSeleccionado)
                let copiaFichaPais = JSON.parse(JSON.stringify(this.state.fichaPais));
                copiaFichaPais["CeldaValor1"] = objetoSeleccionado.value;
                this.setState({
                    fichaPais: copiaFichaPais
                });

                document.getElementById('nombrePais').value = objetoSeleccionado.etiqueta;
                setTextInputLongitud(['nombrePais']);
                this.onTituloChange()
            }
        }
    }

    componentDidMount(){
        setTextInputLongitud(['nombrePais', 'fpai_Slug','CeldaValor1', 'tituloSEO', 'descripcionSEO', 'enlaceSEO', 'script']);
    }

    render() {
        // console.log(this.state.fichaPais);
        // console.log(Number(this.state.fichaPais["estado"]));

        return (
            <div className="">
               <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de Configuración General
                        </a>
                        <Link to="/ficha-pais">
                            / Ficha Mercado
                        </Link>
                        <span> / Agregar Ficha Mercado</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Ficha de Mercado
                </div>
                <div className="div_Modulos_Noticias">
                    <div className="div_WrapperEditarPagina">
                        {/* <div className="txtFile x-1">
                                <DropDownList 
                                    valor={[{pais_Id:-999}]} 
                                    isMulti={false} 
                                    name="nUbicacionCodigo" 
                                    id="nUbicacionCodigo"  
                                    onChange={this.handleInputChange}
                                    componente={"UbicacionFichaPais"}
                                />
                        </div> */}
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Codigo ISO país" id='CeldaValor1' maxLength={3} onChange={() => this.onTituloChange()} className={`data-test data-form ${this.state.Validacion.CeldaValor1.Error ? "error" : ""}`}/>
                            <span id="longitudCeldaValor1"></span>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Nombre" id='nombrePais' maxLength={255} onChange={() => this.onTituloChange()} className={`data-test data-form ${this.state.Validacion.nombrePais.Error ? "error" : ""}`}/>
                            <span id="longitudnombrePais"></span>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Slug" id='fpai_Slug'  maxLength={255} className={`data-test data-form ${this.state.Validacion.fpai_Slug.Error ? "error" : ""}`}/>
                            <span id="longitudfpai_Slug"></span>
                        </div>
                      
                        {/* <div className="x-2 relative">
                            <span className="subirImagen" onClick={() => this.showModalFile("divBanderaUpload")}/>
                            <input type="text" placeholder="Bandera" id="bandera" className={`data-test data-form ${this.state.Validacion.bandera.Error ? "error" : ""}`}  maxLength={255}/>
                            <br />
                        </div>
                       */}
                        <div className='row w-100 justify-content-end'>
                            {/* <div className="col-md-6 p-2 text-center">
                                <div>
                                    {!this.state.miniaturaBandera
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaBandera.startsWith('http') || this.state.miniaturaBandera.startsWith('data:image')) ? this.state.miniaturaBandera :  (BASE_URL_PAIS + this.state.miniaturaBandera)} />
                                            <br/><br/>
                                        </div>
                                        )
                                    }
                                </div>
                            </div> */}
                            {/* <div className="col-md-6 p-2 text-center">
                                <div>
                                    {!this.state.miniaturaMapa
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaMapa.startsWith('http') || this.state.miniaturaMapa.startsWith('data:image')) ? this.state.miniaturaMapa :  (BASE_URL_PAIS + this.state.miniaturaMapa)} />
                                            <br/><br/> 
                                        </div>
                                        )
                                    }
                                </div>
                            </div> */}
                        </div>
                        
                        <div className="divWrapperActive" style={{ maxWidth: 215 }}>
                            <div>
                                <span>Habilitado</span>
                            </div>
                            <div>
                                <div 
                                    className={this.state.fichaPais.estado ? "containerActive backgroundPosition" : "containerActive"} 
                                    onClick={() => this.checkedValidate("estado")}
                                >
                                    <div className={this.state.fichaPais.estado ? "actionActive leftPosition" : "actionActive"}/>
                                </div>
                                <span>
                                    {this.state.fichaPais.estado ? "Activado" : "Desactivado"}
                                </span>
                            </div>
                        </div>
                       
                    </div>
                    <div className="clear"></div>

                    <div className="divModulo_Seo">
                        <h2>Configuración <strong>SEO</strong></h2>
                        <div className="divWrapperModulo_Seo">
                            <div className="txtFile x-1">
                                <input type="text" placeholder="SEO Título" id='tituloSEO' maxLength="255" className="data-test data-form"/>
                                <span id="longitudtituloSEO"></span>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="SEO Descripción" id='descripcionSEO' maxLength="255" style={{height:"100px"}} className="data-test data-form"/>
                                <span id="longituddescripcionSEO"></span>
                            </div>
                            <div className="txtFile x-1 relative">
                                <span className="subirImagen" onClick={() => this.showModalFile("divImagenSEOUpload")} />
                                <input type="text" placeholder="SEO Imagen" id='imagenSEO' className='data-test data-form' maxLength={255}/>
                            </div>
                            <div className='row w-100 justify-content-end'>
                            <div className="col-md-12 p-2 text-center">
                                <div>
                                    {!this.state.miniaturaImagenSEO
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaImagenSEO.startsWith('http') || this.state.miniaturaImagenSEO.startsWith('data:image')) ? this.state.miniaturaImagenSEO :  (BASE_URL_PAIS + this.state.miniaturaImagenSEO)} />
                                            <br/><br/>  
                                        </div>
                                        )
                                    }
                                </div>
                            </div>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Enlace" id='enlaceSEO' maxLength="255" className="data-test data-form"/>
                                <span id="longitudenlaceSEO"></span>
                            </div>
                            <div className="divWrapperActive">
                                <div>
                                    <span>Motores de busqueda <br />seguir enlaces</span>
                                </div>
                                <div>
                                    <div className={this.state.fichaPais.seguirBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("seguirBuscadoresSEO")}>
                                        <div className={this.state.fichaPais.seguirBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaPais.seguirBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                                <div>
                                    <span>Mostrar Pagina <br />Motores de Búsqueda </span>
                                </div>
                                <div>
                                    <div className={this.state.fichaPais.mostrarBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("mostrarBuscadoresSEO")}>
                                        <div className={this.state.fichaPais.mostrarBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaPais.mostrarBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="Pegue aquí su código JavaScript" id="script" style={{height:"100px"}} maxLength="32000" className="data-test data-form"/>
                                <span id="longitudscript"></span>
                            </div>
                        </div>
                    </div>
                    <div className="divContenedorBtn_Noticias">
                        <a href="#" className="btnActivo" onClick={(event) => this.handleClickGuardar(event)}>{this.state.guardando ? 'PROCESANDO...' : 'GUARDAR'}</a>
                        <a href="#" onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <ModalFile class={"divImagenSEOUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "imagenSEO", "imagenSEOData")} tipo="image"/>
                <ModalFile class={"divBanderaUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "bandera", "banderaData")} tipo="image"/>
            </div>
        )
    }
}